var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewVtDocsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 389.183 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FFFFFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5953",
    "data-name": "Group 5953"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.265,2.064v.014H129.11L119.3,30.426c-2.921,8.471-5.587,16.369-6.82,21.666h-.169c-1.345-5.836-3.74-13.462-6.537-21.891L96.4,2.078H84.46L105.6,61.346h13.115L137.1,11.277h15.565V61.346h11.145V11.277H182.18V2.066Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6420",
    "data-name": "Group 6420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    className: "cls-1",
    d: "M63.271,63.271H0V0H63.271ZM10.542,45.2v7.688H31.711V45.2Zm0-16.157v7.685H50.664V29.047Zm0-15.958v7.69H50.664V13.089Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Docs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.168,61.511V2.114h19.837c17.488,0,27.957,11.137,27.957,29.609,0,18.56-10.469,29.783-28.567,29.783Zm18.735-7.83c13.544,0,20.235-7.889,20.235-21.953,0-14.008-6.7-21.78-19.69-21.78H215.122V53.681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.718,39.441c0-13.862,8.208-23.055,20.765-23.055s20.763,9.193,20.763,23.055c0,13.775-8.207,22.97-20.763,22.97S260.718,53.216,260.718,39.441Zm32.769-.03c0-8.526-3.828-15.774-11.977-15.774-8.207,0-12.035,7.248-12.035,15.774,0,8.556,3.828,15.718,12.035,15.718,8.15,0,11.978-7.162,11.978-15.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.234,39.441c0-13.6,8.116-23.055,20.674-23.055,10.117,0,17.458,5.976,18.386,14.964h-8.438a9.556,9.556,0,0,0-9.8-7.656c-7.248,0-12.065,6-12.065,15.545,0,9.714,4.728,15.834,12.065,15.834a9.513,9.513,0,0,0,9.8-7.657h8.44c-.956,8.672-7.772,15-18.3,15C316.062,62.411,308.234,52.869,308.234,39.441Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.454,29.235c-1.017-2.989-3.51-5.976-8.91-5.976-4.93,0-8.642,2.436-8.607,5.859-.029,3.02,2.088,4.669,6.99,5.828L377,36.569c8.178,1.886,12.181,5.774,12.181,12.065,0,8.062-7.453,13.777-18.214,13.777-10,0-16.558-4.44-18.009-12.326l8.384-1.277c1.042,4.379,4.379,6.613,9.569,6.613,5.684,0,9.362-2.7,9.362-6.149,0-2.782-2-4.7-6.29-5.654l-7.54-1.661c-8.354-1.856-12.183-6.06-12.183-12.383,0-7.885,7.135-13.194,17.2-13.194,9.628,0,15.049,4.53,16.849,11.455Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVtDocsWhite);
export default __webpack_public_path__ + "static/media/new-vt-docs-white.5f5aaea0830ecc9017eb9dea4c155490.svg";
export { ForwardRef as ReactComponent };